export default "__VITE_ASSET__1Bv1KPbY__"